module.exports = __webpack_public_path__ + "d75e82de058379b8ac9356fda2683b3b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-18@2x.png
// module id = 505
// module chunks = 0